import tinycolor from 'tinycolor2';

const ColorModel = require('./color-model');

module.exports = Backbone.Model.extend({
  url: function () {
    return this.baseUrl + (this.id ? 'texts/' + this.id : 'texts');
  },

  getServerModel: function () {
    const result = _(this.attributes).clone();
    let rgb = tinycolor(result.data.color_code).toRgb();
    result.data.color_code = rgb.b * 65536 + rgb.g * 256 + rgb.r;

    if (result.data.stroke_color) {
      rgb = tinycolor(result.data.stroke_color).toRgb();
      result.data.stroke_color = rgb.b * 65536 + rgb.g * 256 + rgb.r;
    }

    return result;
  },

  parse: function (resource) {
    if (Array.isArray(resource)) {
      return resource.map(this.parse, this);
    }

    var b = parseInt(resource.data.stroke_color / 65536);
    var g = parseInt((resource.data.stroke_color - b * 65536) / 256);
    var r = parseInt(resource.data.stroke_color - b * 65536 - g * 256);
    var color = tinycolor('rgb(' + r + ',' + g + ',' + b + ')');

    resource.data.stroke_color = color.toHexString();

    var b = parseInt(resource.data.color_code / 65536);
    var g = parseInt((resource.data.color_code - b * 65536) / 256);
    var r = parseInt(resource.data.color_code - b * 65536 - g * 256);
    var color = tinycolor('rgb(' + r + ',' + g + ',' + b + ')');

    resource.data.color_code = color.toHexString();

    return resource;
  },

  toJSON: function () {
    const result = Backbone.Model.prototype.toJSON.call(this);

    result.data.name = result.data.name ||
      result.data.family;

    result.data.default_content = result.data.default_content ||
      result.data.name ||
      result.data.family;

    return result;
  },

  sync: ColorModel.prototype.sync
});
